/**
 * Profile Data - Braian Ariel Maciel
 * Personal and professional information
 */

export const profile = {
  // Basic Info
  name: "Braian Ariel Maciel",
  role: "CTO / Full-Stack & Platform Engineer",
  tagline: "Building scalable fintech solutions that don't crash at 3am",

  // Location & Availability
  currently: "Spain/España",
  location: "Argentina",
  remoteWork: true,
  globalAvailability: true,
  experience: "5+ years",
  availability: "Open to opportunities",

  // Contact
  email: "braiantablet@gmail.com", // TODO: Agregar email real
  github: "https://github.com/Braiunito", // TODO: Agregar GitHub real
  linkedin: "https://www.linkedin.com/in/braianarielmaciel/", // TODO: Agregar LinkedIn real

  // About (short version)
  shortBio: "CTO with a strong foundation in Symfony/Vue and real experience operating multi-tenant fintech platforms. Capable of leading strategy and delivery, building teams, and maintaining production with criteria (security, performance, data and operations).",

  // Highlights
  highlights: [
    "CTO at SmartEscrow (Fintech Platform)",
    "Full-Stack expertise: Symfony + Vue.js + DevOps",
    "Multi-tenant architecture specialist",
    "5+ years building production systems",
    "Competition winner (INET National Recognition)"
  ],

  // Education
  education: [
    {
      institution: "Universidad Siglo 21",
      degree: "Computer Science",
      period: "2020-2025",
      status: "In pause/stand-by"
    },
    {
      institution: "UTN",
      degree: "Systems Engineering",
      period: "2018-2020",
      status: "Completed partial"
    },
    {
      institution: "E.E.T. N°24 Simón de Iriondo",
      degree: "Computer Science Professional",
      period: "2011-2017",
      status: "Completed"
    }
  ],

  // Awards & Recognition
  awards: [
    "INET National Recognition in Programming",
    "Provincial Award in Programming Competition",
    "2x Local Programming Awards"
  ]
};

export default profile;
